import { atom } from 'jotai';
import { MapData_Base } from '~/common/typescript/models/MapData';

export const isMapLoadedDoneAtom = atom<boolean>(false);

export const mapDataListAtom = atom<MapData_Base[]>([]);

export const mapDataListRefreshTrigger = atom<number>(0);

export const selectedMapDataAtom = atom<MapData_Base | null>(null);

export const showStylePopupAtom = atom<boolean>(false);

export const showLegendPanelAtom = atom<boolean>(false);

export const showLibraryPanelAtom = atom<boolean>(false);

export const showGeocollectPanelAtom = atom<boolean>(false);

export const showForestWatchPanelAtom = atom<boolean>(false);

export const showUploadTaskPanelAtom = atom<boolean>(false);

export const showDataTableAtom = atom<boolean>(false);

export const showSearchAddressPanelAtom = atom<boolean>(false);

export const showCommentPanelAtom = atom<boolean>(false);

export const showSharePanelAtom = atom<boolean>(false);

export const showElementDetailPanelAtom = atom<boolean>(false);

export const showSamPanelAtom = atom<boolean>(false);

export const showChatSamPanelAtom = atom<boolean>(false);

export const showNavigatorPanelAtom = atom<boolean>(false);

export const showSatelliteImagePanelAtom = atom<boolean>(false);

export const showMapDataUpdatePanelAtom = atom<boolean>(false);

export const editingMapDataAtom = atom<MapData_Base | null>(null);

export const allDisplayedDataBoundsAtom = atom<string | null>(null);

export const currentMapDataBoundsAtom = atom<string | null>(null);

export const mapDataDisplayedBoundsAtom = atom<string | null>(null);

export const showMinimapAtom = atom<boolean>(true);

export const showMapDataDetailPanelAtom = atom<boolean>(false);

export const editingMapDataDetailAtom = atom<MapData_Base | null>(null);

export interface ContextMenuPosition {
  x: number;
  y: number;
  lng: number;
  lat: number;
}

export const mapContextMenuAtom = atom<ContextMenuPosition | null>(null);

// TASK_39: Vector Tile toggle atoms for Photos
export const showFreePhotoVectorTilesAtom = atom<boolean>(true);
export const showCollectPhotoVectorTilesAtom = atom<boolean>(true);